import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { SECTORS, SECTOR_ROUTES } from "@/data/content";

const CHAPTERS = [
    { n: "01", title: "STANDARDIZE", text: "Repeatable systems, defined specifications and structured stages for every project." },
    { n: "02", title: "DIGITALIZE", text: "A technology-enabled customer experience — from estimation to project tracking." },
    { n: "03", title: "AUTOMATE", text: "Process automation that brings clarity, speed and communication to construction." },
    { n: "04", title: "SCALE", text: "From individual homes to townships, industrial projects and mega developments." },
];

export const AboutManifesto = () => (
    <section id="about" data-testid="about-section" className="paper-grid relative overflow-hidden py-24 lg:py-36">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
                <div className="lg:col-span-7">
                    <SectionHeading
                        id="about-heading"
                        overline="About OMSIVO"
                        title={<>A modern construction, engineering, design <span className="text-flame-dark">&</span> development company.</>}
                        description="OMSIVO works across residential, commercial, industrial, industrial sheds, mega projects, township development, engineering, surveying, architecture, interior, turnkey construction, project management and building materials."
                    />
                    <Reveal delay={0.2}>
                        <div className="mt-10 flex flex-wrap gap-2" data-testid="about-sector-chips">
                            {SECTORS.map((s) => (
                                <Link key={s} to={`/services/${SECTOR_ROUTES[s]}`} data-testid={`about-chip-${SECTOR_ROUTES[s]}`}
                                    className="rounded-full border border-omsivo-navy/12 bg-white px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-omsivo-slate shadow-sm transition-colors hover:border-flame hover:text-flame-dark">
                                    {s}
                                </Link>
                            ))}
                        </div>
                    </Reveal>
                </div>
                <div className="lg:col-span-5">
                    <Reveal delay={0.1}>
                        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-omsivo-slate">
                            Operating Philosophy
                        </p>
                    </Reveal>
                    <div className="mt-6">
                        {CHAPTERS.map((c, i) => (
                            <Reveal key={c.n} delay={0.08 * i}>
                                <div className="group flex items-center gap-6 border-b border-omsivo-navy/10 py-6 transition-colors hover:border-flame/50" data-testid={`philosophy-${c.title.toLowerCase()}`}>
                                    <span className="text-outline-dark font-display text-5xl font-black transition-all group-hover:text-flame group-hover:[-webkit-text-stroke:0px] lg:text-6xl">
                                        {c.n}
                                    </span>
                                    <div>
                                        <h3 className="font-display text-xl font-extrabold tracking-wide text-omsivo-navy">{c.title}</h3>
                                        <p className="mt-1 text-sm leading-relaxed text-slate-600">{c.text}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);
